import React from 'react'
import PageHeader from '../components/PageHeader'

function Seminar() {
  return (
    <div>
      <PageHeader title="RUSA" />
    </div>
  )
}

export default Seminar
